<template>
  <div class="county-info">
    <img class="bg" :src="county && county['地图']" alt="">
    <ul class="turbine-list">
      <li v-for="point in pointList" :key="point.left + point.top" class="turbine"
          :style="{ left: point.left + '%', top: point.top + '%' }">
        <img class="blade autorotation" src="../assets/img/blade.png" alt="">
        <img class="tower" src="../assets/img/tower.png" alt="">
        <css-doodle class="css-doodle" grid="4x4">
          :doodle {
          @size: 50px 50px;
          perspective: 10px;
          }
          :container {
          perspective: 50px;
          transform-style: preserve-3d;
          }
          position: absolute;
          top: 0;
          left: 0;
          width: 2px;
          height: 2px;
          border-radius: 50%;
          left: 50%;
          top: 50%;
          background: hsl(@rn(10, 0, 255), @rn(10%, 90%), @rn(90%, 100%));
          transform: scale(@rn(1, 4, 3)) translate3d(@rn(-50, 50, 3)px, @rn(-50, 50, 3)px, @rn(-100, 20)px);
          animation: move @rn(5, 15, 3)s infinite @rn(-20, -10, 3)s linear alternate;
          box-shadow: 0 0 1px #fff, 0 0 5px #fff;
          @keyframes move {
          100% {
          margin-top: 100px;
          }
          }
        </css-doodle>
      </li>
    </ul>
    <div v-if="county.name === '昌黎县'" class="haishangdengludian">
      <div class="turbine">
        <img class="blade autorotation" src="../assets/img/blade.png" alt="">
        <img class="tower" src="../assets/img/tower.png" alt="">
        <css-doodle class="css-doodle" grid="4x4">
          :doodle {
          @size: 50px 50px;
          perspective: 10px;
          }
          :container {
          perspective: 50px;
          transform-style: preserve-3d;
          }
          position: absolute;
          top: 0;
          left: 0;
          width: 2px;
          height: 2px;
          border-radius: 50%;
          left: 50%;
          top: 50%;
          background: hsl(@rn(10, 0, 255), @rn(10%, 90%), @rn(90%, 100%));
          transform: scale(@rn(1, 4, 3)) translate3d(@rn(-50, 50, 3)px, @rn(-50, 50, 3)px, @rn(-100, 20)px);
          animation: move @rn(5, 15, 3)s infinite @rn(-20, -10, 3)s linear alternate;
          box-shadow: 0 0 1px #fff, 0 0 5px #fff;
          @keyframes move {
          100% {
          margin-top: 100px;
          }
          }
        </css-doodle>
      </div>
    </div>
    <!--  陆上/海上  -->
    <div class="tag-group">
      <div v-for="item in Object.keys(this.county['风机'])" :key="item" :class="{'is-active': curTurbineType === item }" @click="toggleTurbineType(item)">{{ item }}风电项目</div>
<!--      <div :class="{'is-active': curTurbineType === '海上' }" @click="toggleTurbineType('海上')">海上风电项目</div>-->
    </div>
    <HeaderTop :title="'金风科技在秦皇岛-' + county.name + '项目推动情况'"></HeaderTop>
    <TimelineCarousel :items="county['大事记']" :maxItemLength="6" position="right" @change="openDialog">
      <template v-slot:item="{ item }">
        <h4 class="title" v-html="item['标题']"></h4>
      </template>
    </TimelineCarousel>
    <el-dialog custom-class="cur-timeline" :visible.sync="dialog.isShow" :modal-append-to-body="false" :align-center="true" :title="curTimeline['标题']">
      <div class="pic-panel cur-timeline">
        <div class="header"></div>
        <div class="body">
          <div class="top">
            <h2 class="title">{{ curTimeline['标题'] }}</h2>
          </div>
          <div class="info" v-html="curTimeline['简介']"></div>
        </div>
      </div>
    </el-dialog>
    <el-button class="go-back" type="text" @click="goBack">
      <i class="el-icon-back"></i>返回
    </el-button>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'county',

  data () {
    return {
      qinhuangdao: this.$store.state.page.pageConfig['金风科技在秦皇岛'],
      county: this.$store.state.page.curCounty,
      timeline: [],
      curTimeline: {},
      dialog: { // 时间线
        isShow: false,
        title: '',
        timelineIndex: 0
      },
      pointList: [],
      curTurbineType: '陆上'
    }
  },
  components: {
    HeaderTop: () => import('/src/components/HeaderTop'),
    TimelineCarousel: () => import('/src/components/TimelineCarousel')
  },
  props: [],
  computed: {
    ...mapState({
      pageConfig: state => state.page.pageConfig,
      curCounty: state => state.page.curCounty
    }),
    cityList () {
      return this.qinhuangdao['城市列表']
    }
  },
  watch: {
    curCounty: {
      handler (val) {
        this.county = val
        this.toggleTurbineType()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    openDialog (item, index) {
      this.curTimeline = item
      this.dialog.timelineIndex = index
      this.dialog.isShow = true
    },
    goBack () {
      this.$store.commit('page/DELETE_CURCOUNTY')
    },
    toggleTurbineType (type = '陆上') {
      this.curTurbineType = type
      this.pointList = this.county['风机'][type]
    }
  },
}
</script>
<style lang="scss" scoped>
@import "~/src/assets/css/common.scss";

.county-info{
  width: 100vw;
  height: 100vh;
  .bg{
    object-fit: cover;
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
  }
  .el-timeline{

  }
}

.tag-group{
  position: fixed;
  left: 50px;
  bottom: 100px;
  div{
    background: url("../assets/img/icon-tag-type.png") no-repeat left center;
    background-size: contain;
    width: 336px;
    height: 60px;
    font-size: 26px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 60px;
    text-shadow: 0px 0px 10px rgba(30,198,255,0.8);
    margin-bottom: 20px;
    padding: 0 40px;
    cursor: pointer;
    &.is-active {
      text-shadow: 0px 0px 11px #FF8809;
      background-image: url("../assets/img/icon-tag-type-active.png");
    }
  }
}

.haishangdengludian{
  position: fixed;
  left: 45.5%;
  top: 60%;
  z-index: 11;
  width: 337px;
  height: 341px;
  background: url("../assets/img/haishang-dengludian.png") no-repeat center / cover;
  .turbine{
    left: unset;
    right: 111px;
    bottom: 120px;
  }
}
</style>
